import type {
  MassRewardSendResponse,
  MassRewardUser,
  MassRewardUsersResponse,
  SendMassRewardArgs,
} from '../../types/massReward';
import { apiUrl, parseJsonOrThrow } from '../http';

const ENDPOINT = '/php/mass-reward.php';

/** GET `?action=get_users` — active users for the author/initiator/recipient selectors. */
export const getMassRewardUsers = async (): Promise<MassRewardUser[]> => {
  const res = await fetch(apiUrl(`${ENDPOINT}?action=get_users`));
  const result = await parseJsonOrThrow<MassRewardUsersResponse>(res);
  if (result.status === 'error') {
    throw new Error(
      result.message ?? 'Не вдалося завантажити список користувачів'
    );
  }
  return result.data ?? [];
};

/** POST `?action=send` — bulk accrual to every `user_ids` entry in a single request. */
export const sendMassReward = async (
  args: SendMassRewardArgs
): Promise<MassRewardSendResponse> => {
  const res = await fetch(apiUrl(`${ENDPOINT}?action=send`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(args),
  });
  const result = await parseJsonOrThrow<MassRewardSendResponse>(res);
  if (result.status === 'error') {
    throw new Error(result.message ?? 'Помилка нарахування');
  }
  return result;
};
